import lz from 'lz-string';
import cookie from 'js-cookie';
import URI from 'urijs';
import { oidc as oidcUtils } from '@clubmed/utils';
import graphqlClient from 'Utils/graphql-client/graphqlClient';
import { getCodeFromStatus } from 'Utils/ple-utils/mapper';
import { PAYMENT_PRE_GET_FORM_DATA } from 'Utils/request/requestDictionary';
import { paymentRedirectMutation } from 'Utils/graphql-query-helper/booking/payment-redirect/paymentRedirectQuery';
type Params = {
  location: string;
  bookingStatus: string;
  locale: string;
  isCart: boolean;
  customerNeolaneId?: string;
};
export const buildPostPaymentUrl = (params: Params) => {
  const { location, bookingStatus, locale, isCart, customerNeolaneId } = params || {};
  const cartPath = isCart ? '/c' : ''; // Add only 1 letter to limit the url length for the PSPs

  if (!bookingStatus) {
    return null;
  }

  return new URI(location)
    .query('')
    .hash('')
    .path(
      customerNeolaneId
        ? `pr/{paymentId}/${locale}/customer/${customerNeolaneId}/${getCodeFromStatus(bookingStatus)}${cartPath}`
        : `pr/{paymentId}/${locale}/${getCodeFromStatus(bookingStatus)}${cartPath}`,
    )
    .toString();
};
export const getPaymentTrackingDatas = (orderId: string) => {
  const value = cookie.get(`PRE_PAYMENT_INFOS-${orderId}`);
  return value ? oidcUtils.fromUriEncodedState(value) : null;
};
export const getFormData = (params: any, appContext: AppContext) =>
  graphqlClient.runNoCacheQuery(paymentRedirectMutation(params), appContext, {
    requestName: PAYMENT_PRE_GET_FORM_DATA,
  });
export const extractPayload = (payload: any) => {
  if (!payload) {
    return null;
  }

  let value = null;

  try {
    value = lz.decompressFromEncodedURIComponent(payload);
    return JSON.parse(value);
  } catch (e) {
    console.error('extractPayload', e, ' for value:', value); // eslint-disable-line no-console

    return null;
  }
};
export const mapTransportResume = (transports?: StayEntity['transport']) => {
  return transports
    ? [...transports.inbounds, ...transports.outbounds].map(({ travelSections }) =>
        travelSections.map(({ transport, departure, arrival }) => {
          return {
            company: {
              name: transport.companyOperator?.label,
              id: transport.companyOperator?.id,
            },
            origin: departure.cityId,
            destination: arrival.cityId,
            departure: {
              apc: departure.id,
              date: departure.date,
            },
            arrival: {
              apc: arrival.id,
              date: arrival.date,
            },
          };
        }),
      )
    : [];
};
